// @ts-nocheck
/* eslint-disable consistent-return */
import React, { FunctionComponent, useState, useRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
// @ts-ignore
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'
import { DropdownIndicator } from 'Shared/components/DropdownIndicator'
import MenuList from 'Shared/components/MenuList'
import {
  customStyles,
  mobileCustomStyles,
} from 'Shared/components/CustomStyles'
import { IconCheckMark } from 'Stories/Icon/Icon.stories'
import {
  ActionsForSelectGenresAndLanguagesEnum,
  CampaignToSchedule,
} from 'Types/index'
import { useContainerSize } from 'Constants/functions'
import {
  languageAddedEventSchedulingCampaign,
  locationEvent,
} from 'Helpers/tagManager'
import { getUserId } from 'Redux/selectors/auth'
import {
  getAmountOfCampaigns,
  getCampaignToSchedule,
} from 'Redux/selectors/campaigns'
import { SelectLanguagesProps } from './SelectLanguagesProps'

import {
  LanguagesSelectItem,
  LanguagesSelectItemAnimation,
  IconCheckMarkWrapper,
} from './styles'

const SelectLanguages: FunctionComponent<SelectLanguagesProps> = ({
  selectedLanguages,
  languages,
  setSelectedLanguages,
  campaignType,
  campaignId,
  onMobileSearchOpen,
}) => {
  const { t } = useTranslation()
  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selectRef = useRef<any>(null)
  const isMobile = useMediaQuery({ maxWidth: 576 })
  const userId = useSelector(getUserId)
  const campaignDetails: CampaignToSchedule = useSelector(getCampaignToSchedule)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)

  const [selectedStyleLanguagesId, setSelectedStyleLanguagesId] = useState(null)
  const [inputValueLanguages, setInputValueLanguages] = useState('')

  const handleInputChangeLanguages = (characterEntered: string) => {
    setInputValueLanguages(characterEntered)
  }

  const optionsSelectLanguages = options => {
    const languagesOptions = options
      .filter(item => item.id !== 3)
      .map(item => ({
        value: item.id,
        label:
          item.language_name.slice(0, 1).toUpperCase() +
          item.language_name.slice(1),
      }))
    return [...languagesOptions]
  }

  const onChangeSelectLanguages = (selectedOptions, { action, option }) => {
    const hasNoPreferences = Boolean(
      selectedLanguages.find(item => item.value === 1)
    )

    if (
      (action === ActionsForSelectGenresAndLanguagesEnum.REMOVE_VALUE ||
        action === ActionsForSelectGenresAndLanguagesEnum.POP_VALUE) &&
      selectedLanguages.length === 1
    ) {
      return setSelectedLanguages(
        optionsSelectLanguages([{ id: 2, language_name: 'No Vocal' }])
      )
    }

    if (
      (action === ActionsForSelectGenresAndLanguagesEnum.REMOVE_VALUE ||
        action === ActionsForSelectGenresAndLanguagesEnum.POP_VALUE) &&
      selectedLanguages.length === 2 &&
      hasNoPreferences
    ) {
      return setSelectedLanguages(
        optionsSelectLanguages([
          { id: 2, language_name: 'No Vocal' },
          { id: 1, language_name: 'No preference' },
        ])
      )
    }

    if (action === ActionsForSelectGenresAndLanguagesEnum.SELECT_OPTION) {
      locationEvent()
      languageAddedEventSchedulingCampaign(
        campaignDetails.type,
        option.value,
        option.label,
        campaignType,
        userId,
        campaignId,
        campaignDetails.type === 'first' ? 1 : amountOfCampaigns
      )

      if (option.value === 2) {
        return setSelectedLanguages([option])
      }

      const selectedOptionsWithoutNoVocal = selectedOptions.filter(
        lang => lang.value !== 2
      )

      setSelectedStyleLanguagesId(option.value)
      // TODO
      setTimeout(() => {
        setSelectedLanguages(selectedOptionsWithoutNoVocal)
        setSelectedStyleLanguagesId(null)
      }, 500)
    } else {
      setSelectedLanguages(selectedOptions)
    }
  }

  const mappedListedItems = useMemo(() => {
    const languagesOptions = languages
      .map(item => ({
        value: item.id,
        label:
          item.language_name.slice(0, 1).toUpperCase() +
          item.language_name.slice(1),
      }))
      // @ts-ignore
      .filter(item => item.id !== 3 && item.value !== 2)
    return [{ value: 2, label: 'No Vocal' }, ...languagesOptions]
  }, [languages])

  const formatOptionLabelLanguages = (
    { label, value },
    { inputValue, selectValue }
  ) => {
    const inputLength = inputValue.length

    const index = label.toLowerCase().indexOf(inputValue.toLowerCase())
    const selectValueLabel = selectValue.map(item => item.label)

    if (selectValueLabel.includes(label)) {
      return <div>{label}</div>
    }

    if (selectedStyleLanguagesId === value) {
      return (
        <LanguagesSelectItemAnimation>
          <IconCheckMarkWrapper>
            <IconCheckMark />
          </IconCheckMarkWrapper>

          <span>
            {label.slice(0, index)}
            <strong>
              {index === 0
                ? inputValueLanguages.slice(0, 1).toUpperCase() +
                  inputValueLanguages.slice(1)
                : inputValueLanguages}
            </strong>
            {label.slice(index + inputLength)}
          </span>
          <span />
        </LanguagesSelectItemAnimation>
      )
    }

    if (selectedStyleLanguagesId !== value && index === -1) {
      return (
        <LanguagesSelectItem>
          <span>{label}</span>
          <span />
        </LanguagesSelectItem>
      )
    }

    return (
      <LanguagesSelectItem>
        <span>
          {label.slice(0, index)}
          <strong style={index === 0 ? { textTransform: 'capitalize' } : null}>
            {inputValueLanguages}
          </strong>
          {label.slice(index + inputLength)}
        </span>
        <span />
      </LanguagesSelectItem>
    )
  }

  const onMenuOpen = async () => {
    await new Promise(resolve => setTimeout(resolve, 10))

    if (isMobile && selectRef.current.state.menuIsOpen) {
      onMobileSearchOpen()
      setTimeout(() => window.scrollTo(0, 0), 200)
    }
  }

  useContainerSize(selectRef)

  return (
    <Select
      ref={selectRef}
      isMulti
      menuPortalTarget={document.body}
      styles={
        isMobile
          ? { ...customStyles, ...mobileCustomStyles }
          : { ...customStyles }
      }
      options={isMobile ? [] : mappedListedItems}
      placeholder={t('createCampaignPage.startTypingLanguageName')}
      classNamePrefix="multi-select"
      closeMenuOnSelect={false}
      blurInputOnSelect={false}
      label={t('createCampaignPage.noVocal')}
      value={selectedLanguages.filter(item => item.value !== 1)}
      inputValue={inputValueLanguages}
      isSearchable={!isMobile}
      components={{ DropdownIndicator, MenuList }}
      formatOptionLabel={formatOptionLabelLanguages}
      onInputChange={handleInputChangeLanguages}
      onChange={onChangeSelectLanguages}
      onMenuOpen={onMenuOpen}
    />
  )
}

export default SelectLanguages
